import { Link } from "react-router-dom";

type Reason = {
  icon: string;
  title: string;
  desc: string | null;
};

const reasons: Reason[] = [
  {
    icon: "ri-shield-check-line",
    title: "Servicio discreto y confidencial",
    desc: "Entendemos que muchas situaciones son delicadas. Trabajamos con total discreción, especialmente en casos de síndrome de Diógenes o herencias.",
  },
  {
    icon: "ri-flashlight-line",
    title: "Rapidez y servicio urgente",
    desc: "Sabemos que el tiempo es dinero. Respondemos en menos de 48 horas y ofrecemos servicio urgente cuando la situación lo requiere.",
  },
  {
    icon: "ri-recycle-line",
    title: "Gestión responsable de residuos",
    desc: null,
  },
  {
    icon: "ri-money-euro-circle-line",
    title: "Presupuesto sin compromiso",
    desc: "Te damos un precio claro y transparente antes de empezar. Sin sorpresas ni costes ocultos. Puedes pedir presupuesto por fotos o visita.",
  },
  {
    icon: "ri-team-line",
    title: "Equipo profesional y de confianza",
    desc: "Nuestro equipo está formado y tiene experiencia en todo tipo de vaciados, desde pisos estándar hasta casos de limpieza extrema.",
  },
  {
    icon: "ri-map-pin-2-line",
    title: "Especialistas en Girona y comarca",
    desc: "Conocemos bien el territorio: Girona ciudad, Salt, Sarrià de Ter, Banyoles, Cassà de la Selva y todas las poblaciones del Gironès.",
  },
];

export default function WhyUs() {
  return (
    <section className="py-20 md:py-28 bg-white" style={{ fontFamily: "'Montserrat', sans-serif" }}>
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left: Image */}
          <div className="relative">
            <img
              src="https://public.readdy.ai/ai/img_res/51dfcfc0dfa3adb9b6958107fc28d657.jpg"
              alt="Equipo GIROBUIT trabajando en vaciado de piso en Girona"
              title="Equipo profesional de vaciado de pisos y locales en Girona - GIROBUIT"
              className="w-full h-[480px] object-cover object-top rounded-2xl"
              width={700}
              height={480}
              loading="lazy"
              decoding="async"
              sizes="(max-width: 768px) 100vw, 50vw"
            />
            <div className="absolute -bottom-6 -right-6 bg-[#ff0000] text-white rounded-2xl p-6 hidden md:block">
              <div className="text-3xl font-900" style={{ fontWeight: 900 }}>12+</div>
              <div className="text-sm font-600 mt-1" style={{ fontWeight: 600 }}>Años de<br />experiencia</div>
            </div>
          </div>

          {/* Right: Reasons */}
          <div>
            <span className="inline-block text-xs font-700 text-[#b30000] uppercase tracking-widest mb-3" style={{ fontWeight: 700 }}>
              ¿Por qué elegirnos?
            </span>
            <h2 className="text-3xl md:text-4xl font-800 text-[#330000] mb-8" style={{ fontWeight: 800 }}>
              El equipo de vaciado de pisos en Girona en el que puedes confiar
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {reasons.map((r) => (
                <div key={r.title} className="flex gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-[#ff0000]/10 flex-shrink-0 mt-0.5">
                    <i className={`${r.icon} text-lg text-[#b30000]`}></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-700 text-[#330000] mb-1" style={{ fontWeight: 700 }}>{r.title}</h3>
                    {r.desc !== null ? (
                      <p className="text-xs text-gray-600 leading-relaxed">{r.desc}</p>
                    ) : (
                      <p className="text-xs text-gray-600 leading-relaxed">
                        Todo lo que retiramos tiene un{" "}
                        <a
                          href="https://web.girona.cat/netejairesidus/deixalleria/funcionament"
                          rel="nofollow"
                          target="_blank"
                          className="underline text-[#b30000] hover:text-[#330000] transition-colors duration-200"
                        >
                          destino responsable
                        </a>
                        : donación, reciclaje o punto limpio autorizado. Cumplimos la normativa vigente.
                      </p>
                    )}
                  </div>
                </div>
              ))}
            </div>
            <div className="mt-8">
              <Link
                to="/empresa"
                className="inline-flex items-center gap-1.5 text-sm font-600 text-[#b30000] hover:gap-3 transition-all duration-200 cursor-pointer"
                style={{ fontWeight: 600 }}
              >
                Conoce nuestro equipo y cómo trabajamos <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
